import { Component, Input, OnChanges, SimpleChanges, ViewChild, ComponentFactoryResolver, ViewContainerRef} from '@angular/core';
import { WidgetItem } from '../../shared-datatypes/widget-items';
import { WidgetComponent } from '../../shared-datatypes/widget.component';
import { WidgetDirective } from './widget.directive';

@Component({
	selector: 'app-widget-container',
	templateUrl: './widget-container.component.html',
	styleUrls: ['./widget-container.component.css']
})

export class WidgetContainerComponent implements OnChanges {

	@Input() widgets: WidgetItem | any;
	@ViewChild(WidgetDirective, { static: true }) widgetHost!: WidgetDirective;
	loader: boolean = true;

	ngOnChanges(change: SimpleChanges) {
		this.loadDefaultComponent();
	}

	loadDefaultComponent() {
		if (this.widgets) {
			this.loadComponent();
		} else {
			this.loader = true;
		}
	}

	loadComponent() {
		if (this.widgets.hasOwnProperty('initializing')) {
			if (this.widgets['initializing']) {
				console.log("Do Nothing");
				this.loader = false;
			} else {
				this.loader = false;
				//let componentFactory = this.componentFactoryResolver.resolveComponentFactory(this.widgets.component);

				/*clearning previous component*/
				let viewContainerRef = this.widgetHost.viewContainerRef;
				viewContainerRef.clear();

				let componentRef = viewContainerRef.createComponent(this.widgets.component);
				(<WidgetComponent>componentRef.instance).data = this.widgets.data;
			}
		} else {
			this.loader = false;
			//let componentFactory = this.componentFactoryResolver.resolveComponentFactory(this.widgets.component);

			/*clearning previous component*/
			let viewContainerRef = this.widgetHost.viewContainerRef;
			viewContainerRef.clear();

			let componentRef = viewContainerRef.createComponent(this.widgets.component);
			(<WidgetComponent>componentRef.instance).data = this.widgets.data;
		}
		// if (this.widgets) {
		// 	this.loader = false;
		// 	let componentFactory = this.componentFactoryResolver.resolveComponentFactory(this.widgets.component);

		// 	/*clearning previous component*/
		// 	let viewContainerRef = this.widgetHost.viewContainerRef;
		// 	viewContainerRef.clear();

		// 	let componentRef = viewContainerRef.createComponent(componentFactory);
		// 	(<WidgetComponent>componentRef.instance).data = this.widgets.data;
		// } else {
		// 	this.loader = true;
		// }
	}

}
